import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

export const ViewFormStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
        },
        pageWrapper: {
            position: "relative",
            height: "calc(100vh - 380px)",
            overflowY: "auto",

            [theme.breakpoints.up("md")]: {
                padding: "30px",
                paddingLeft: "95px",
            },
            [theme.breakpoints.down("sm")]: {
                height: "calc(100% - 370px)",
                overflowX: "hidden",
                overflowY: "auto",
            },
        },
        accordionCard: {
            "& > div > div": {
                padding: "0px",
            },
            "& .MuiCollapse-container": {
                margin: "0px",
                background: "transparent",
            },
        },
        accordionHeader: {
            borderStyle: "solid",
            "&.Mui-expanded": {
                borderBottom: "  1px dashed #ced4da",
                backgroundColor: "#f9f9f9",
                boxShadow: "0 5px 10px #ccc",
            },
            "& .MuiAccordionSummary-content": {
                alignItems: "center",
                padding: "18px 18px 15px 0px",
            },
        },
        cardHead: {
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            "& > div > h4": {
                fontSize: "10px",
                fontWeight: 700,
                lineHeight: "12px",
                color: "#191919",
                letterSpacing: "-0.15px",
            },
            "& > div > p": {
                fontSize: "14px",
                fontWeight: "bold",
                lineHeight: "12px",
                color: "#191919",
                letterSpacing: "-0.15px",
            },
        },
        formHeader: {
            background: "#3C3C3B",
            padding: "22px 20px",
            width: "100%",
            borderBottom: "solid 1px #449B23",
            marginBottom: "20px",
            marginTop: "20px",
            "& .title": {
                fontSize: "21px",
                lineHeight: "25px",
                color: "#fff",
                fontWeight: "bolder",
            },
            [theme.breakpoints.down("sm")]: {
                padding: "16px 12px",
                marginBottom: "16px",
                "& .title": {
                    fontSize: "18px",
                    lineHeight: "22px",
                },
            },
        },
        formContent: {
            padding: "0px",
        },
        backToSignatures: {
            position: "absolute",
            top: "9px",
            left: "0",
            width: "100%",
            background: "#D0E6C7",
            display: "flex",
            alignItems: "center",
            paddingLeft: "95px",
            gap: "8px",
            "& .arrowIcon": {
                backgroundColor: "#449B23",
                height: "30px",
                width: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                cursor: "pointer",
                "& svg": {
                    fontSize: "20px",
                },
            },
            "& > button": {
                fontSize: "12px",
                lineHeight: "18px",
                color: "#3C3C3B",
                background: "transparent",
                fontWeight: 700,
                letterSpacing: "-0.18px",
                textDecoration: "none",
                "&:hover": {
                    color: "#3C3C3B",
                    background: "transparent",
                },
            },
        },
        signatureSection: {
            "& div.MuiFormControl-root": {
                flexDirection: "row !important",
                gap: "12px",
            },
            "& .MuiInputLabel-root": {
                display: "flex",
                alignItems: "end",
            },
            "& .MuiInputBase-root": {
                width: "160px !important",
                marginTop: "0px !important",
            },
        },
        signatureCanvas: {
            width: "100%",
            maxWidth: "540px",
            height: "90px",
            border: "1px solid #CED4DA",
            borderRadius: "4px",
            "& canvas": {
                width: "100% !important",
                height: "90px !important",
            },
        },
        signatureControls: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "540px",
            gap: "12px",
            flexWrap: "wrap",
        },
        signatureDateField: {
            minWidth: "140px",
            flex: "0 0 auto",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "15px",
            marginTop: "10px",
            width: "100%",
            "& .MuiInputBase-root": {
                marginTop: "0px !important",
            },
        },
        signatureClearButton: {
            flex: "0 0 auto",
            fontSize: "14px",
        },
        signatureSubmitButton: {
            flex: "1 1 auto",
            minWidth: "120px",
        },
        signatureBottomSection: {
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            boxShadow: "0px -3px 6px #00000029",
            opacity: 1,
        },
        isMobileaccordionHeader: {
            "& .MuiAccordionSummary-content": {
                padding: "16px 0",
                width: "100%",
                "& > svg": {
                    height: "16px",
                    width: "16px",
                },
            },
        },
        reservationFormBox: {
            "& .MuiTypography-root": {
                fontSize: "14px",
                lineHeight: "18px",
                color: "#191919",
                letterSpacing: "-0.15px",
                display: "grid",
                gap: "5px",
                gridTemplateColumns: "1fr 1fr",
            },

            // "& .MuiTypography-root > span:last-child": {
            //     textAlign: "right",
            // },
        },
        reservationDetailsBox: {
            "& .MuiTypography-root": {
                fontSize: "14px",
                lineHeight: "18px",
                color: "#191919",
                letterSpacing: "-0.15px",
            },
        },
        signatureCheckbox: {
            "& .MuiSvgIcon-root": {
                fill: "#556ED1",
            },
        },
        dividerContainer: {
            paddingLeft: "0 !important",
            paddingRight: "0 !important",

            "& .MuiDivider-root": {
                height: "1px",
                background: "#7F7F7F 0% 0% no-repeat padding-box",
                opacity: 1,
            },
        },
        reservationInnerBox: {
            "& .MuiTypography-root": {
                fontSize: "14px",
                lineHeight: "18px",
                color: "#191919",
                letterSpacing: "-0.15px",
                display: "flex",
                gap: "15px",
            },
        },

        [theme.breakpoints.down("sm")]: {
            accordionDetails: {
                padding: "10px 0",
            },
            signatureSection: {
                "& div.MuiFormControl-root": {
                    flexDirection: "column !important",
                    gap: "8px",
                    alignItems: "stretch",
                },
                "& .MuiInputBase-root": {
                    width: "100% !important",
                },
            },
            signatureControls: {
                flexDirection: "column",
                alignItems: "stretch",
                gap: "12px",
            },
            signatureDateField: {
                minWidth: "unset",
                width: "100%",
            },
            signatureClearButton: {
                alignSelf: "flex-end",
            },
            signatureSubmitButton: {
                width: "100%",
            },
            signatureBottomSection: {
                padding: "0",
                bottom: "63px",
            },
            isMobileaccordionHeader: {
                "& .MuiAccordionSummary-content": {
                    padding: "16px !important",
                },
            },
            reservationFormBox: {
                "& .MuiTypography-root": {
                    fontSize: "12px",
                },
            },
            reservationDetailsBox: {
                "& .MuiTypography-root": {
                    fontSize: "12px",
                },
            },
        },
        [theme.breakpoints.down("xs")]: {
            signatureCanvas: {
                height: "80px",
                "& canvas": {
                    height: "80px !important",
                },
            },
            signatureBottomSection: {
                padding: "0",
                bottom: "63px",
            },
            isMobileaccordionHeader: {
                "& .MuiAccordionSummary-content": {
                    padding: "16px !important",
                },
            },
            reservationFormBox: {
                "& .MuiTypography-root": {
                    fontSize: "12px",
                },
            },
            reservationDetailsBox: {
                "& .MuiTypography-root": {
                    fontSize: "12px",
                },
            },
        },
    };
});
